import axios, { AxiosError } from 'axios';

async function getNovidades(filters: ApiFiltersType, token: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade`,
      params: {
        ...filters,
      }
    });
    
    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function getNovidade(token: string | null, idNovidade: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade/${idNovidade}`,
    });
    
    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function getVisualizacoesNovidade(token: string | null, idNovidade: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade/visualizacoes/${idNovidade}`,
    });
    
    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function updateNovidade(postBody: Novidade, token: string | null, idNovidade: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'put',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade/${idNovidade}`,
      data: postBody
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function insertNovidade(postBody: Novidade, token: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'post',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade`,
      data: postBody
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function deleteNovidade(token: string | null, idNovidade: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'delete',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade/${idNovidade}`,
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function deleteVisualizacaoNovidade(token: string | null, idVisualizacao: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'delete',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade/visualizacao/${idVisualizacao}`,
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

async function updateNovidadeStatus(postBody: { status: boolean }, token: string | null, idNovidade: string) {
  try {
    const response = await axios({
      headers: {
        Authorization: token,
      },
      method: 'put',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/novidade/status/${idNovidade}`,
      data: postBody
    });

    return { status: response.status, data: response.data }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        return { status: axiosError.response.status, data: axiosError.message }
      }
      console.error(axiosError.message);
      return { status: axiosError.status ? axiosError.status : 500, data: axiosError.message }
    } else {
      return { status: 400, data: error }
    }
  }
}

export { getNovidades, getNovidade, updateNovidade, insertNovidade, deleteNovidade, updateNovidadeStatus, getVisualizacoesNovidade, deleteVisualizacaoNovidade };
